<template>
    <div>
        <competition-filter-link :filterLayout="filterLayout" :filterData="filterSet.filter"
                                 :sortData="filterSet.sort" :paginationData="filterSet.page"></competition-filter-link>
        <competition-list-link :listLayout="listLayout" :paginationData="filterSet.page"
                               :competitionData="List"></competition-list-link>
        <pagination-link :paginationLayout="paginationLayout" :paginationData="filterSet.page"
                         :type="competitionType"></pagination-link>
    </div>
</template>

<script>
import CompetitionFilterLink from "@/components/competition/CompetitionFilterLink";
import CompetitionListLink from "@/components/competition/CompetitionListLink";
import PaginationLink from "@/components/competition/PaginationLink";
import competitionUtil from "@/components/competition/competitionUtil";
import listMixins from "@/mixins/listMixins";
import filterMixins from "@/mixins/filterMixins";
import util from "@/mixins/util";

const {filterConfig} = competitionUtil;

export default {
    name: "CompetitionListComponent",
    mixins: [competitionUtil, filterMixins, listMixins],
    components: {
        CompetitionFilterLink,
        CompetitionListLink,
        PaginationLink
    },
    inject: [],
    provide() {
        return {
            setPage: this.setPage,
            setFilter: this.setFilter,
            setSort: this.setSort,
            setCompetitionListData: this.setData,
        }
    },
    props: {
        competitionType: {default: ''},
        competitionKey: {default: ''},
        memberKey: {default: 0},
    },
    data() {
        return {
            getFunc: '',
            listLayout: '',
            filterLayout: '',
            paginationLayout: '',
            sortOptions: {},
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.initConfig();
        this.setFilterConfig(filterConfig)
        this.setParserType('url', this.$route.fullPath);
    },
    mounted() {
        this.getList(true);
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        initConfig() {
            let config = this.returnCompetitionConfig(this.competitionType);
            this.listLayout = config.listLayout;
            this.filterLayout = config.filterLayout;
            this.paginationLayout = config.paginationLayout;
            this.getFunc = config.getFunc;
            this.listApiParamSet = config.listApiParamSet;
            this.pageRow = config.pageRow;
            this.keyName = config.keyName;

            if (config.pageRow && config.pageRow != this.filterSet.page.size) {
                this.pageRow = config.pageRow;
                this.filterSet.page.size = config.pageRow;
                this.pageClass.setterPage('size', this.pageRow);
            }

            let params = JSON.parse(JSON.stringify(this.listApiParamSet));

            console.log(this.competitionKey);
            if (!util.isEmpty(this.competitionKey)) {
                if (!util.isEmpty(this.keyName)) {
                    params[this.keyName] = this.competitionKey;
                } else {
                    params.cid = this.competitionKey
                }
            }

            if (!util.isEmpty(this.memberKey) && this.memberKey !== 0) {
                // params.no = this.memberKey
                params[this.keyName] = this.memberKey
            }
            let listOptions = {
                url: this.$api.$competition[this.getFunc],
                defaultParams: params,
            }
            this.sortOptions = config.sortOptions
            this.setSortOptions(this.sortOptions)
            this.initList('api', listOptions);
        },
        setData(key, value) {
            this[key] = value
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
